<template>
  <div class="seaFreightDataStatisticsDetail">
    <van-form label-width="120px">
      <div v-if="form.menuState == 1">
        <div class="title">{{ $t.meta.basicTitle }}</div>

        <van-field
          v-model="form.Month"
          :label="$t.seaFreightDataStatistics.month"
          readonly
        />

        <van-field
          v-model="form.WayBillCount"
          :label="$t.seaFreightDataStatistics.wayBillCount"
          readonly
        />

        <van-field
          v-model="form.CostBillCount"
          :label="$t.seaFreightDataStatistics.costBillCount"
          readonly
        />

        <van-field
          v-model="form.Containers20Count"
          :label="$t.seaFreightDataStatistics.cabinet20"
          readonly
        />

        <van-field
          v-model="form.Containers40Count"
          :label="$t.seaFreightDataStatistics.cabinet40"
          readonly
        />

        <van-field
          v-model="form.Containers40HQCount"
          :label="$t.seaFreightDataStatistics.cabinet40HQ"
          readonly
        />

        <van-field
          v-model="form.ContainersOthersCount"
          :label="$t.seaFreightDataStatistics.cabinetOthers"
          readonly
        />

        <div class="title">{{ $t.seaFreightDataStatistics.amountTitle }}</div>

        <div class="subTotal" v-if="listAmount && listAmount.length > 0">
          <div class="subTotal-label">
            {{ $t.seaFreightDataStatistics.payAmount }}
          </div>
          <div
            class="subTotal-item"
            v-for="(item, index) in listAmount"
            :key="index"
          >
            <div class="item1">{{ item.key }}</div>
            <div class="item2">{{ item.value }}</div>
          </div>
        </div>

        <div class="subTotal" v-if="cabinetClass && cabinetClass.length > 0">
          <div class="subTotal-label">
            {{ $t.seaFreightDataStatistics.cabinetClass }}
          </div>
          <div
            class="subTotal-item"
            v-for="(item, index) in cabinetClass"
            :key="index"
          >
            <div class="item1">{{ item.key }}</div>
            <div class="item2">{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.PWB_Number"
          :label="$t.seaFreightDataStatistics.mainWbNumber"
          readonly
        />
        <van-field
          v-model="form.WB_Number"
          :label="$t.seaFreightDataStatistics.sideWbNumber"
          readonly
        />
        <van-field
          v-model="form.DeliveryCode"
          :label="$t.seaFreightDataStatistics.deliveryPort"
          readonly
        />
        <van-field
          v-model="form.ReceiveCode"
          :label="$t.seaFreightDataStatistics.destinationPort"
          readonly
        />
        <van-field
          v-model="form.DepartureDate"
          :label="$t.seaFreightDataStatistics.departureDate"
          readonly
        />
        <van-field
          v-model="form.ArrivalDate"
          :label="$t.seaFreightDataStatistics.arrivalDate"
          readonly
        />
        <van-field
          v-model="form.DaysDifference"
          :label="$t.seaFreightDataStatistics.daysDifference"
          readonly
        />
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "seaFreightDataStatisticsDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      menuState: 1,
      listAmount: [],
      cabinetClass: [],
    };
  },
  created() {
    var data = JSON.parse(
      localStorage.getItem("seaFreightDataStatisticsDetail")
    );
    this.form = data;
    this.menuState = this.form.menuState;
    this.firstLoad();
  },
  methods: {
    firstLoad() {
      if (this.menuState == 1) {
        var test = Object.entries(this.form.PaidAmountDic);
        var array = test.map(([key, value]) => ({
          key,
          value,
        }));
        this.listAmount = array;

        var test = Object.entries(this.form.CabinetClassDic);
        var array = test.map(([key, value]) => ({
          key,
          value,
        }));
        this.cabinetClass = array;
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.seaFreightDataStatisticsDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
}
</style>
